import Vue from 'vue';
import Vuex from 'vuex';
import tour from './tour/index'

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        tour,
    }
});